import { useEffect, useRef, useCallback } from 'react';
import { combineRefs } from '../utils/ref';

// Example 1 (single ref):
//   const autoFocusRef = useAutofocus({ autofocus: true });
//   <input ref={autoFocusRef} />
//
// Example 2 (combining multiple refs for a single element):
//   const combineRefs = useAutofocus({ autofocus: true });
//   <button ref={combineRefs([ref, innerRef])} />
const useAutofocus = ({
  autofocus
}) => {
  const elementRef = useRef(null);
  useEffect(() => {
    if (autofocus) {
      elementRef.current?.focus?.();
    }
  }, [autofocus, elementRef]);
  return useCallback(
  // eslint-disable-next-line consistent-return
  elementOrArrayOfRefs => {
    if (Array.isArray(elementOrArrayOfRefs)) {
      return combineRefs(elementOrArrayOfRefs.concat(elementRef));
    }
    elementRef.current = elementOrArrayOfRefs;
  }, [elementRef]);
};

// used by legacy React.Component Class components
export const autofocusLegacyComponentDidMount = ({
  ref,
  autofocus
}) => {
  if (autofocus && ref && ref.current && ref.current.focus) {
    ref.current.focus();
  }
};
export default useAutofocus;
//# sourceMappingURL=useAutofocus.js.map